// React and related imports
import React from 'react';

// Flowbite components
import { Table } from 'flowbite-react';

// Custom Components
import { EditButton } from '../Shared/EditButton';
import { TableCell } from '../Table/Table';

// Redux selectors, hooks, and actions
import { useAppDispatch } from '../../redux/hooks/useAppDispatch';
import {
  openContentContextModal,
  setSelectedContentContext,
} from '../../redux/slices/contentContextSlice';

// Types and Interfaces
import { IContentContext } from '../../common/interfaces/ContentContext.interface';

// i18 Translation
import { TFunction } from 'i18next';

// Utils
import { localizePrayerName } from '../../utils/localizePrayerName';
import { formatLocalizedTime } from '../../utils/formatLocalizedTime';
import { getLocalizedValueFromMultiLangValues } from '../../utils/getLocalizedValueFromMultiLangValues';

// Constants
import { statusIcons } from '../../common/constants/statusIcons';

interface ContentContextTableBodyProps {
  t: TFunction<'translation', undefined>;
  tableData: IContentContext[];
}

export const ContentContextTableBody: React.FC<
  ContentContextTableBodyProps
> = ({ t, tableData }) => {
  const dispatch = useAppDispatch();

  const noDataPlaceHolder = '--';

  const handleEditClick = (contentContext: IContentContext) => {
    dispatch(setSelectedContentContext(contentContext));
    dispatch(openContentContextModal());
  };

  return (
    <>
      {tableData.map((contentContext, index) => (
        <Table.Row key={index} className="bg-white">
          <TableCell classes="whitespace-nowrap text-center font-medium">
            {getLocalizedValueFromMultiLangValues(contentContext.title) ||
              noDataPlaceHolder}
          </TableCell>
          <TableCell>
            <span
              className={`me-2 inline-block h-2 w-2 rounded-full ${
                statusIcons[contentContext.status]
              }`}
            ></span>
            {t(`status.${contentContext.status}`) || noDataPlaceHolder}
          </TableCell>
          <TableCell>
            {localizePrayerName(contentContext.prayerName) || noDataPlaceHolder}
          </TableCell>
          <TableCell>
            {formatLocalizedTime(contentContext.time) || noDataPlaceHolder}
          </TableCell>
          <TableCell>
            {contentContext.adhanDelta || noDataPlaceHolder}
          </TableCell>
          <TableCell>
            {contentContext.createdAt
              ? new Date(contentContext.createdAt).toLocaleString()
              : noDataPlaceHolder}
          </TableCell>
          <TableCell>
            <EditButton onClick={() => handleEditClick(contentContext)} />
          </TableCell>
        </Table.Row>
      ))}
    </>
  );
};
